define('PromptNoticeView',['underscore', 'backbone', 'jquery', 'template!blocks/notice/prompt','CSS3Events'], function (_, Backbone, $, template,CSS3Events) {

    //
    // Confirm Alert view
    //

    return Backbone.View.extend({

        events: {
            'click button': 'onClick'
        }, initialize: function (options) {
            this.render(options);
        },

        render: function (options) {
            var self = this;
            if (typeof options == 'string') {
                options = {title: options};
            }
            function setDefaultOption(key,defaultValue){
                if(_.isUndefined(options[key])){
                    options[key] = defaultValue;
                }
            }
            setDefaultOption('title',false);
            setDefaultOption('subtitle',false);
            setDefaultOption('placeholder',false);
            setDefaultOption('validation',t('Ok','UI'));
            setDefaultOption('cancel',t('Annuler','UI'));
            var html = $(template(options));
            this.setElement(html);
            $('.site').append(html);
            self.$('button').focus();
            this.show();
        },

        onClick: function (e) {
            var view = this,
                buttonValue= $(e.currentTarget).data('value'),
                value = view.$('#inputval').val();

            if (!value && buttonValue == true)
            {
                    return ;
            }
            if (buttonValue == false)
            {
                value = false;
            }
            this.trigger('noticeClose', value);
            this.hide();
        },

        show: function () {
            var self = this;
            setTimeout(function () {
                self.$el.addClass('active');
            }, 1)
        },

        hide: function () {
            var self = this;
            self.$el.removeClass('active');
            self.$('.content').one(CSS3Events('transitionend'), function () {
                self.remove();
            });
        }

    });
});
